import { call, delay, put, select, takeLatest } from 'redux-saga/effects';
import { COPY_PX } from 'src/store/ActionTypes';
import * as api from 'src/store/api';

function* fetchSegments(action) {
  try {
    const { payload: query } = action;
    const segments = yield call(api.fetchSegments, query);
    yield put({
      type: COPY_PX.FETCH_SEGMENTS_SUCCEEDED,
      payload: segments,
    });
  } catch (e) {
    yield put({
      type: COPY_PX.FETCH_SEGMENTS_FAILED,
    });
  }
}

function* selectGridRow(action) {
  const { payload: row } = action;
  const {
    copyPx: { maxGridRowSelection, selectedGridRows },
  } = yield select();
  if (selectedGridRows.length < maxGridRowSelection) {
    yield put({
      type: COPY_PX.SET_SELECTED_GRID_ROWS,
      payload: [...selectedGridRows, row],
    });
  } else {
    const [, ...restRows] = selectedGridRows;
    yield put({
      type: COPY_PX.SET_SELECTED_GRID_ROWS,
      payload: [...restRows, row],
    });
  }
}

function* deselectGridRow(action) {
  const { payload: row } = action;
  const {
    copyPx: { selectedGridRows },
  } = yield select();
  const filteredSelectedGridRows = selectedGridRows.filter(({ id }) => id !== row.id);
  yield put({
    type: COPY_PX.SET_SELECTED_GRID_ROWS,
    payload: filteredSelectedGridRows,
  });
}

function* editSegment(action) {
  try {
    const {
      payload: { id, payload },
    } = action;
    yield call(api.updateSegment, id, payload);
    yield put({
      type: COPY_PX.EDIT_SEGMENT_SUCCEEDED,
      payload: {
        id,
        payload,
      },
    });
  } catch (e) {
    yield put({
      type: COPY_PX.EDIT_SEGMENT_FAILED,
    });
  } finally {
    yield delay(500);
    yield put({
      type: COPY_PX.UNSET,
      payload: 'editSegmentStatus',
    });
  }
}

function* fetchHighValueWords(action) {
  const {
    payload: { segmentId, clusterId, wvmId },
  } = action;
  let exit = false;
  let generated = false;
  while (!exit) {
    try {
      const highValueWords = yield call(api.getHighValueWords, segmentId, clusterId, wvmId);
      yield put({
        type: COPY_PX.FETCH_HIGH_VALUE_WORDS_SUCCEEDED,
        payload: highValueWords,
      });
      exit = true;
    } catch (e) {
      if (e.status === 404 && !generated) {
        // high value words are not yet generated
        // Trigger a api call to generate them
        const resp = yield call(api.generateHighValueWords, segmentId, clusterId, wvmId);
        if (resp) {
          generated = true;
        }
      }
      if (!generated) {
        yield put({
          type: COPY_PX.FETCH_HIGH_VALUE_WORDS_FAILED,
        });
        exit = true;
      }
    }
  }
}

function* fetchSegmentsSaga() {
  yield takeLatest(COPY_PX.FETCH_SEGMENTS, fetchSegments);
}

function* fetchHighValueWordsSaga() {
  yield takeLatest(COPY_PX.FETCH_HIGH_VALUE_WORDS, fetchHighValueWords);
}

function* onRowSelectSaga() {
  yield takeLatest(COPY_PX.SELECT_GRID_ROW, selectGridRow);
}

function* onRowDeselectSaga() {
  yield takeLatest(COPY_PX.DESELECT_GRID_ROW, deselectGridRow);
}

function* editSegmentSaga() {
  yield takeLatest(COPY_PX.EDIT_SEGMENT, editSegment);
}

export default [
  fetchSegmentsSaga(),
  fetchHighValueWordsSaga(),
  onRowSelectSaga(),
  onRowDeselectSaga(),
  editSegmentSaga(),
];
